import DinesLink from "@/components/library/Misc/DinesLink";
import type { Venue } from "@/types/api/contracts/venue";
import { cn } from "@/utils/css";

export interface ISideBarProfile {
  organisation?: Venue;
  collapseSidebar: boolean;
}

const SideBarProfile: React.FC<ISideBarProfile> = ({
  organisation,
  collapseSidebar,
}) => {
  return (
    <div className="sticky bottom-0 bg-gray-800 p-5">
      <DinesLink href="/settings/venue">
        <div className="flex w-full cursor-pointer items-center space-x-4">
          <div className={cn(collapseSidebar ? "md:hidden" : "flex flex-col")}>
            <p className="font-bold text-lg text-white ">
              {organisation?.name}
            </p>
          </div>
        </div>
      </DinesLink>
    </div>
  );
};

export default SideBarProfile;
